import { billMethodById } from '../../../../utils/renewals-util';
import * as ValidationFields from '../../../../constants/ValidationFields';
import { ADDITIONAL_CHARGES_PRECISION } from '../../../../constants/decimal-points';
import { formatNumber } from '../../../../utils/format-number-util';

const mapFromRenewal = (lineItems, onSelectLineItem) => {
  return lineItems.map((lineItem) => ({
    lineItemId: lineItem.lineItemId,
    billMethod: lineItem.billMethod,
    description: {
      name: lineItem.description,
      code: lineItem.itemCode
    },
    isAdjustable: lineItem.isAdjustable,
    onClick: lineItem.isAdjustable
      ? () => onSelectLineItem(lineItem.lineItemId)
      : null,
    rentalPrice: {
      base: lineItem.originalPrice.priceRental,
      adjusted: lineItem.adjustedPrice.priceRental,
      requiresApproval:
        lineItem.validationFields &&
        lineItem.validationFields.includes(ValidationFields.RENTAL_PRICE)
    },
    salesPrice: {
      base: lineItem.originalPrice.priceItem,
      adjusted: lineItem.adjustedPrice.priceItem,
      requiresApproval:
        lineItem.validationFields &&
        lineItem.validationFields.includes(ValidationFields.SALES_PRICE)
    },
    replacePrice: {
      base: lineItem.originalPrice.priceReplace,
      adjusted: lineItem.adjustedPrice.priceReplace,
      requiresApproval:
        lineItem.validationFields &&
        lineItem.validationFields.includes(ValidationFields.REPLACE_PRICE)
    },
    washPrice: {
      base: lineItem.originalPrice.priceWash,
      adjusted: lineItem.adjustedPrice.priceWash,
      requiresApproval:
        lineItem.validationFields &&
        lineItem.validationFields.includes(ValidationFields.WASH_PRICE)
    },
    quantity: {
      base: lineItem.baseQuantity.rentalQuantity,
      adjusted: lineItem.adjustedQuantity.rentalQuantity,
      requiresApproval:
        lineItem.validationFields &&
        lineItem.validationFields.includes(ValidationFields.RENTAL_QUANTITY)
    },
    deliveryQuantity: {
      base: lineItem.baseQuantity.deliveryQuantity,
      adjusted: lineItem.adjustedQuantity.deliveryQuantity,
      requiresApproval:
        lineItem.validationFields &&
        lineItem.validationFields.includes(ValidationFields.DELIVERY_QUANTITY)
    },
    circulatingInventory: {
      base: lineItem.baseQuantity.circulatingInventory,
      adjusted: lineItem.adjustedQuantity.circulatingInventory,
      requiresApproval:
        lineItem.validationFields &&
        lineItem.validationFields.includes(
          ValidationFields.CIRCULATING_INVENTORY
        )
    },
    circulationInventoryMultiplier: {
      base: lineItem.baseQuantity.circulationInventoryMultiplier,
      adjusted: lineItem.adjustedQuantity.circulationInventoryMultiplier,
      requiresApproval:
        lineItem.validationFields &&
        lineItem.validationFields.includes(
          ValidationFields.CIRCULATION_INVENTORY_MULTIPLIER
        )
    },
    deliveryQuantityMultiplier: {
      base: lineItem.baseQuantity.deliveryQuantityMultiplier,
      adjusted: lineItem.adjustedQuantity.deliveryQuantityMultiplier,
      requiresApproval:
        lineItem.validationFields &&
        lineItem.validationFields.includes(
          ValidationFields.DELIVERY_QUANTITY_MULTIPLIER
        )
    },
    rentQuantityMultiplier: {
      base: lineItem.baseQuantity.rentQuantityMultiplier,
      adjusted: lineItem.adjustedQuantity.rentQuantityMultiplier,
      requiresApproval:
        lineItem.validationFields &&
        lineItem.validationFields.includes(
          ValidationFields.RENT_QUANTITY_MULTIPLIER
        )
    },
    deliveryPerWeek: {
      base: lineItem.baseQuantity.deliveryPerWeek,
      adjusted: lineItem.adjustedQuantity.deliveryPerWeek,
      requiresApproval:
        lineItem.validationFields &&
        lineItem.validationFields.includes(
          ValidationFields.DELIVERY_PER_WEEK
        )
    },
    weeklyUsage: {
      base: lineItem.baseQuantity.weeklyUsage,
      adjusted: lineItem.adjustedQuantity.weeklyUsage,
      //BM6-todo: place holder
      requiresApproval: false
    },
    inventoryMaintenance: {
      base: lineItem.baseQuantity.inventoryMaintenance,
      adjusted: lineItem.adjustedQuantity.inventoryMaintenance,
      requiresApproval:
        lineItem.validationFields &&
        lineItem.validationFields.includes(
          ValidationFields.INVENTORY_MAINTENANCE
        ),
      inventoryMaintenanceType: lineItem.baseQuantity.inventoryMaintenanceType
    },
    easyCarePrice: lineItem.imageCarePrice,
    prodGroupCode: lineItem.itemGroupCode,
    productCode: lineItem.itemCode,
    typeOfMerchandise: lineItem.typeOfMerchandise,
    numberOfWearers:
      lineItem.numberOfWearers != null ? lineItem.numberOfWearers : 0,
    numItemsPerWearer:
      lineItem.numItemsPerWearer != null ? lineItem.numItemsPerWearer : 0,
    size: lineItem.size
  }));
};

const mapFromCustomerProducts = (renewalPriceIncrease, lineItems) =>
  lineItems.map((customerProduct) => ({
    billMethod: billMethodById(customerProduct.billingMethod),
    description: {
      name: customerProduct.productDescription,
      code: customerProduct.productCode
    },
    rentalPrice: {
      base: customerProduct.rentalPrice,
      adjusted:
        customerProduct.rentalPrice != null &&
        customerProduct.isAdjustable &&
        customerProduct.billingMethod !== 4
          ? customerProduct.rentalPrice +
            customerProduct.rentalPrice * renewalPriceIncrease
          : customerProduct.rentalPrice
    },
    salesPrice: {
      base: customerProduct.salesPrice,
      adjusted:
        customerProduct.salesPrice != null &&
        customerProduct.isAdjustable &&
        customerProduct.billingMethod === 4
          ? customerProduct.salesPrice +
            customerProduct.salesPrice * renewalPriceIncrease
          : customerProduct.salesPrice
    },
    replacePrice: {
      base: customerProduct.replacePrice,
      adjusted: customerProduct.replacePrice
/*
        customerProduct.replacePrice != null && customerProduct.isAdjustable
          ? customerProduct.replacePrice +
            customerProduct.replacePrice * renewalPriceIncrease
          : customerProduct.replacePrice
*/
    },
    washPrice: {
      base: customerProduct.washPrice,
      adjusted:
        customerProduct.washPrice != null &&
        customerProduct.isAdjustable &&
        (customerProduct.billingMethod === 3 ||
          customerProduct.billingMethod === 4)
          ? customerProduct.washPrice +
            customerProduct.washPrice * renewalPriceIncrease
          : customerProduct.washPrice
    },
    quantity: {
      base: customerProduct.quantity
    },
    deliveryQuantity: {
      base: customerProduct.deliveryQuantity
    },
    circulatingInventory: {
      base: customerProduct.circulatingInventory
    },
    inventoryMaintenance: {
      base: customerProduct.inventoryMaintenance,
      inventoryMaintenanceType: customerProduct.inventoryMaintenanceType
    },
    weeklyUsage: {
      base: customerProduct.weeklyUsage
    },
    easyCarePrice: customerProduct.imageCarePrice,
    prodGroupCode: customerProduct.prodGroupCode,
    productCode: customerProduct.productCode,
    typeOfMerchandise: customerProduct.typeOfMerchandise,
    numberOfWearers:
      customerProduct.numberOfWearers != null
        ? customerProduct.numberOfWearers
        : 0,
    numItemsPerWearer:
      customerProduct.numItemsPerWearer != null
        ? customerProduct.numItemsPerWearer
        : 0,
    size: customerProduct.size
  }));

const mapLineItems = (renewal, customer, lineItems, onSelectLineItem) =>
  !!renewal
    ? mapFromRenewal(lineItems, onSelectLineItem)
    : mapFromCustomerProducts(customer.renewalPriceIncrease, lineItems);

const emblemChargeTableColumns = [
  {
    header: {
      display: 'Description'
    },
    accessor: (emblemCharge) => ({
      display: emblemCharge.label
    })
  },
  {
    header: {
      display: 'Amount'
    },
    accessor: (emblemCharge) => ({
      display: `$${formatNumber(
        emblemCharge.value,
        ADDITIONAL_CHARGES_PRECISION
      )}`
    })
  }
];

const getRecentProductChangeType = (lineItem, triggerDays= 60) => {
  const now = new Date();

  const checkDate = (date) => {
    if (!date) return false;
    const parsed = new Date(date);
    const diffDays = Math.abs(now - parsed) / (1000 * 60 * 60 * 24);
    return diffDays <= triggerDays;
  };

  const added = checkDate(lineItem.plpcDateActive);
  const removed = checkDate(lineItem.plpcDateInactive);

  return {added, removed};
};

export { mapLineItems, emblemChargeTableColumns, getRecentProductChangeType };
